module.exports = __webpack_public_path__ + "img/handbag.0b263c3b.png";